import type { ToastMessage } from "primereact/toast";

import { withDefaults } from "../../utils/with-defaults";
import { primeIcon } from "../icon";
import type { IconName, IconSize } from "../icon";
import type { ToastSeverity } from "./types-toast";

/** Ícone por severity (frame do Toast): `success-circle` 20; os demais 18 (`toast/icon/size`). */
export const TOAST_ICONS: Record<ToastSeverity, { name: IconName; size: IconSize }> = {
  success: { name: "success-circle", size: 20 },
  info: { name: "info-circle", size: 18 },
  warn: { name: "exclamation-triangle", size: 18 },
  error: { name: "times-circle", size: 18 },
  secondary: { name: "clone", size: 18 },
  contrast: { name: "sparkles", size: 18 },
};

/** Ícone de fechar do frame (`toast/close/icon/size` = 16). */
export const toastCloseIcon = primeIcon("times", 16);

const iconBySeverity = Object.fromEntries(
  Object.entries(TOAST_ICONS).map(([severity, { name, size }]) => [
    severity,
    primeIcon(name, size),
  ]),
) as Record<ToastSeverity, ReturnType<typeof primeIcon>>;

/** Mensagem com os ícones do Figma como padrão: a `icon`/`closeIcon` da tela vencem (`undefined` não apaga o padrão). */
export function withFigmaToastIcons(message: ToastMessage): ToastMessage {
  return withDefaults(
    { icon: iconBySeverity[message.severity ?? "info"], closeIcon: toastCloseIcon },
    message,
  );
}
